import store from "@frameworks/web/redux/store";
import { ADD_DASHBOARD_SUMMARY, DASHBOARD_START_LOADER, DASHBOARD_STOP_LOADER, DASHBOARD_HIDE_ERROR, DASHBOARD_ERROR, } from "@frameworks/web/redux/interfaces/Reports/iDashboardSummary";
class DashboardSummary {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getDashboardSummary(dashboardData, reducerName) {
        this.dispatch({
            type: ADD_DASHBOARD_SUMMARY,
            payload: dashboardData,
            reducerName,
        });
    }
    loader(type) {
        this.dispatch({
            type: DASHBOARD_START_LOADER,
            reducerName: type,
        });
    }
    stopLoader(type) {
        this.dispatch({
            type: DASHBOARD_STOP_LOADER,
            reducerName: type,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: DASHBOARD_ERROR,
            payload: {
                errorData: payload,
            },
            reducerName: errorType,
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: DASHBOARD_HIDE_ERROR,
            reducerName: errorType,
        });
    }
}
export default DashboardSummary;
